
import { TextField } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';

const SelectElement = (props) => {
    const { label, options, value, onChange } = props;
    return (
        <TextField fullWidth select label={label} value={value} onChange={onChange} style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            {
                options && options.map((option) => (
                    <MenuItem key={option.key || option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))
            }
        </TextField>
    )
}

export default SelectElement;